import * as React from "react";

import { useGlobal } from "kanopi-components/useGlobal";
import { deref } from "kanopi-components/utils/primitives";

import api, { $ } from "kw/api";

import { substituteRiskData } from "../substituteRiskData";
import {
  enquiryFields,
  questionFields,
  questionSetFields,
  riskProfileFields,
} from "kw/api/fragments";

type TArgs = {
  coverId: TCoverSection["id"];
  riskProfileId: TRiskProfile["id"];
  globalDataKey: string;
};

export function useStartCoverSummary({ coverId, riskProfileId, globalDataKey }: TArgs) {
  const [, setData] = useGlobal(globalDataKey);
  const [loading, setLoading] = React.useState(true);
  const [enquiry, setEnquiry] = React.useState();
  const [resetEnquiry, setResetEnquiry] = React.useState(true);

  async function startCoverSummary() {
    setLoading(true);
    try {
      const response = await api.mutation(getStartCoverSummaryQuery(), {
        input: {
          coverId,
          riskProfileId,
        },
      });
      const [enquiry, riskProfile] = substituteRiskData(
        deref(response, "startCoverSummary.currentEnquiry", {}),
        deref(response, "startCoverSummary.riskProfile", {})
      );
      setEnquiry(enquiry);
      setData({ riskProfile });
    } finally {
      setLoading(false);
    }
  }
  React.useEffect(() => {
    if (resetEnquiry) {
      startCoverSummary();
      setResetEnquiry(false);
    }
  }, [resetEnquiry]);
  return { enquiry, loading, refetch: setResetEnquiry };
}

function getStartCoverSummaryQuery() {
  return {
    startCoverSummary: [
      {
        input: $("input", "StartCoverSummaryInput"),
      },
      {
        currentEnquiry: {
          ...enquiryFields,
          questionSet: {
            ...questionSetFields,
            questions: {
              ...questionFields,
            },
          },
        },
        riskProfile: riskProfileFields,
      },
    ],
  };
}
